import Vue from 'vue'
import {parseISO, format} from 'date-fns'

// const localeOptions = new Intl.DateTimeFormat().resolvedOptions();

Vue.filter('currency', (value) => {
    if (value === null || value === undefined) {
        return ''
    }

    let val;
    if (typeof(value) == 'string') {

        val = value.replace(/[^\d\.]+/g, '')

        if (!val) {
            return ''
        }
    }
    else {
        val = value;
    }

    let fmt = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});

    return fmt.format(val);
})

Vue.filter('fmtdate', (value, fmt='MM/dd/yyyy h:mm:ss a') => {
    if (value === null || value === undefined) {
        return 'Never'
    }


    let date;
    if (typeof(value) == 'object') {
        date = value
    }
    else {
        date = parseISO(value)
    }

    return `${format(date, fmt)}`
})

